import { useNavigate } from 'react-router-dom';
import { NotFoundPage } from '@azyntor-labs/nexus-ui';
import { useExamAuth } from '@/hooks/useExamAuth';

export const NotFound = () => {
  const navigate = useNavigate();
  const { user, hasAnyRole } = useExamAuth();

  const getDashboardPath = () => {
    if (!user) return '/login';
    if (hasAnyRole(['system_admin', 'super_admin', 'admin'])) return '/admin/dashboard';
    if (hasAnyRole(['instructor', 'teacher'])) return '/teacher/dashboard';
    if (hasAnyRole(['proctor'])) return '/proctoring/monitor';
    return '/student/dashboard';
  };

  // Define quick links based on user role
  const getQuickLinks = () => {
    const links = [
      { name: 'Dashboard', path: getDashboardPath() },
      { name: 'Profile', path: '/profile' },
    ];

    if (hasAnyRole(['system_admin', 'super_admin', 'admin', 'instructor', 'teacher'])) {
      links.push({ name: 'Exams', path: '/teacher/exams' });
    }

    if (hasAnyRole(['student'])) {
      links.push({ name: 'My Results', path: '/student/results' });
    }

    return links;
  };

  return (
    <NotFoundPage
      onGoHome={() => navigate(getDashboardPath())}
      onGoBack={() => navigate(-1)}
      homeLabel="Go to Dashboard"
      backLabel="Go Back"
      quickLinks={getQuickLinks()}
      showSearch={false}
    />
  );
};

export default NotFound;
